export default {
    common: {
        title: 'Contenido AI',
        socialPlanner: 'Planificador social',
        blog: 'Blog',
        funnel: 'Embudo',
        website: 'Sitio web',
        mediaLibrary: 'Biblioteca de medios',
        email: 'Correo electrónico',
        words: 'Palabras',
        variations: 'Variantes',
        thisIsPaidService: 'Esta función es un servicio de pago y generará cargos basados en tu uso',
        all: 'Todos',
    },
};
